
function LogoutComponent() {
    return (
      <div className="LogoutComponent">
        <h1>You are logged out. Goodbye</h1>
        <div>Thanks, we look forward to seeing you again</div>
      </div>
    )
  }   

    export default LogoutComponent;